// extracted by mini-css-extract-plugin
export default {"emailsInWhiteList":"styles_emailsInWhiteList__oBKOO"};